import Base from './Base'

class DataService extends Base {
/**
 * 查询作品数据汇总
 *
 * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272856248741
 * @param {Object} data
 * @returns {Promise}
 */
  queryTotalData(data) {
    return this.post('data_analyse/query_data_summary', data, { noEmpty: true })
  }

  /**
   * 查询热门作品列表
   *
   * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272856248741
   * @param {Object} data
   * @returns {Promise}
   */
  queryHotTable(data) {
    return this.post('data_analyse/query_top_songlist', data, { noEmpty: true })
  }

  /**
   * 查询全部作品列表
   *
   * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272856248741
   * @param {Object} data
   * @returns {Promise}
   */
  queryWorkTable(data) {
    return this.post('data_analyse/query_related_songs', data, { noEmpty: true })
  }

  /**
   * 查询全部作品列表
   *
   * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272856248741
   * @param {Object} data
   * @returns {Promise}
   */
  getCompanyList(data) {
    return this.post('data_analyse/query_related_company', data, { noEmpty: true })
  }

  /**
   * 查询折线图数据
   *
   * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272856248741
   * @param {Object} data
   * @returns {Promise}
   */
  getChartData(data) {
    return this.post('data_analyse/query_song_trends', data, { noEmpty: true })
  }

  /**
   * 查询用户数据
   *
   * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272856248741
   * @param {Object} data
   * @returns {Promise}
   */
  getUsersData(data) {
    return this.post('data_analyse/query_user_fans_data', data, { noEmpty: true })
  }

  /**
   * 查询作品应用数据
   *
   * @param {*} data
   * @returns {Promise}
   */
  queryWordData(data) {
    return this.post('data_analyse/query_related_tracks', data, { noEmpty: true })
  }

  /**
   * 查询作品应用数据
   *
   * @param {*} data
   * @returns {Promise}
   */
  queryWordDataTrends(data) {
    return this.post('data_analyse/get_track_trends', data, { noEmpty: true })
  }

  /**
   * 查询作品上传数据
   *
   * @param {*} data
   * @returns {Promise}
   */
  queryUploadInfo(data) {
    return this.post('data_analyse/get_upload_info', data, { noEmpty: true })
  }

  /**
   * 查询歌曲数据信息
   *
   * @param {*} data
   * @returns {Promise}
   */
  queryTrackInfo(data) {
    return this.post('data_analyse/get_track_stats_info', data, { noEmpty: true })
  }

  /**
   * 查询分布情况
   *
   * @param {*} data
   * @returns {Promise}
   */
  queryUploadInfoDtb(data) {
    return this.post('data_analyse/get_upload_info_distribution', data, { noEmpty: true })
  }

  /**
   * 查询分布情况
  * 获取接入结算系统的url参数
  *
  * @param {Object} data
  * @returns {Promise}
  */
  getIncomeUrlParams(data) {
    return this.post('income/get_income_url_params', data, { noEmpty: false })
  }

  /**
   * 查询AI创作者名下艺人
   * @returns {Promise<{ id: number; singerName: string }>}
   */
  getAISinger() {
    return this.post('data_analyse/get_related_singers_info', null, { noEmpty: false })
  }
}

export default new DataService()
